import { useEffect, useState } from "react";
import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";

const SyncedFormEditDialog = ({ open, form, actionLabel, onClose, onAuthorize }) => {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) {
      setPassword("");
      setLoading(false);
      setError("");
    }
  }, [open]);

  const handleClose = () => {
    if (!loading) onClose();
  };

  const handleAuthorize = async () => {
    setLoading(true);
    setError("");
    try {
      await onAuthorize(password);
    } catch (authorizationError) {
      setError(
        authorizationError?.response?.data?.message ||
          authorizationError?.message ||
          "Authorization failed",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Authorize Synced Form Update</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Enter the synchronization password before continuing to {actionLabel || "edit"}{" "}
          &quot;{form?.label || form?.fileName || "this form"}&quot;.
        </Typography>
        <Alert severity="warning" sx={{ mb: 2 }}>
          This form is synchronized with production. Any saved changes will make the
          development version differ from the current production version until it is
          synchronized again.
        </Alert>
        <TextField
          autoFocus
          fullWidth
          type="password"
          label="Synchronization Password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          disabled={loading}
          autoComplete="new-password"
        />
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading} variant="outlined">
          Cancel
        </Button>
        <LoadingButton
          loading={loading}
          onClick={handleAuthorize}
          disabled={!password.trim()}
          variant="contained"
        >
          Continue
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default SyncedFormEditDialog;